import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (
    user.passwordUpdated === false &&        
    location.pathname !== "/password-update" 
  ) {
    return <Navigate to="/password-update" replace />;
  }
  

  return children;
};

export default ProtectedRoute;
